import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { CircularProgress } from '@mui/material';

interface SpinnerProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const Spinner: React.FC<SpinnerProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                onClose();
            }} 
            disableEscapeKeyDown={true}
            maxWidth="md" 
            id="spinner-dialog"
        >
            <DialogContent>
                <CircularProgress
                    size={60}
                    color="primary"
                />
            </DialogContent>
        </Dialog>
    );
};

export default Spinner;
